import { getApiUrl, ITarget, Target } from "@app/shared";
import { useSignalr } from "@known-as-bmf/react-signalr";
import { useEffect, useRef } from "react";
import { Subscription } from "rxjs";

const TARGET_UPDATE_EVENT = 'ReceiveTarget';
const TARGETS_UPDATE_EVENT = 'ReceiveTargets';
const WATCH_FACILITY_COMMAND = 'WatchFacility';

export function useLiveViewHub(facilityId: string | undefined, onTargetsReceived: (t: Target[]) => void, unsubscribe?: boolean) {
    const { invoke, on } = useSignalr(getApiUrl(`/hubs/liveview`));

    const callbackRef = useRef(onTargetsReceived);
    callbackRef.current = onTargetsReceived;

    useEffect(() => {
        if (!facilityId) return;
        invoke(WATCH_FACILITY_COMMAND, facilityId)
            .catch((err: unknown) => console.error(`[LiveViewHub] WatchFacility FAILED:`, err));
    }, [facilityId, invoke]);

    useEffect(() => {
        let onTargetReceived: Subscription | undefined, onTargetsReceivedSub: Subscription | undefined;

        if (!unsubscribe) {
            onTargetReceived = on<ITarget>(TARGET_UPDATE_EVENT).subscribe((target) => {
                callbackRef.current([new Target(target)]);
            });
            onTargetsReceivedSub = on<ITarget[]>(TARGETS_UPDATE_EVENT).subscribe((targets) => {
                callbackRef.current(targets.map(t => new Target(t)));
            });
        }

        return () => {
            onTargetReceived?.unsubscribe();
            onTargetsReceivedSub?.unsubscribe();
        }
    }, [on, unsubscribe]);
}
